interface IParams {
  key: string,
  value: string
}

export const getParams = () => {
  const url = new URL(document.location.href)
  const params = new URLSearchParams(url.search)

  return params
}

export const setParams = (history: any, params: IParams | IParams[]) => {
  const current = getParams()
  
  if (params instanceof Array) {
    params.forEach(p => {
      current.set(p.key, p.value)
    })
  } else {
    current.set(params.key, params.value)
  }

  if (history) {
    history.replace(`?${current.toString()}`)
  }
}

export const removeParams = (history: any, key: string) => {
  const params = getParams()
  params.delete(key)

  if (history) {
    history.replace(`?${params.toString()}`)
  }
}

export const removeAllParams = (history: any) => {
  const params = getParams()
  params.forEach((value, key) => {
    removeParams(history, key)
  })
}

export default {
  getParams,
  setParams,
  removeParams,
  removeAllParams
}
